import { isAdmin, isDataOp, isTeacher } from "../../helpers/role";
import { Button } from "../../shared/button";

function TaskEditButton(props: { access: string; id: number }) {
  const { access, id } = props;
  let link = "#";
  let title = "";

  if (isAdmin(access) || isDataOp(access) || isTeacher(access)) {
    link = `/task/view/${id}`;
    title = "Просмотр";
  } else {
    return <></>;
  }

  return (
    <Button
      type="link"
      className="TaskEditLink"
      onClick={() => window.open(link, "_blank")}
    >
      {title}
    </Button>
  );
}

export default TaskEditButton;
